import React, { useEffect, useState } from 'react';
import EditCapitalizationModal from './edit-capitalization-modal/Modal';
import {
  Dimmer,
  Table,
  Segment,
  Loader,
  Popup,
  Menu,
  Grid,
  Input,
  Dropdown,
  Label
} from 'semantic-ui-react';
import { iRootDispatch, iRootState } from '../../../store';
import { connect, useSelector } from 'react-redux';
import { AvailableBrokersAndEstatesState } from '../../../store/types/temp-types';
import CustomDatePicker from '../../../components/CustomDatePicker';
import AppMaskedInput from '../../../components/MaskedInput';
import { maskCpfOrCnpj } from '../../../services/masks';
import DetailModal from './DetailModal';
import styled from 'styled-components';
import { translateStatusCapitalization } from '../util';
import ModalAttachFiles from '../../../components/ModalAttachFiles';
import { UserRolesEnum } from '../../../enums/user-roles.enum';
import moment from 'moment-timezone';
import { getCapitalizations } from '../../../services/capitalization';
import { ListCapitalizationInterface } from '../ListCapitalizationInitial.interface';
import { CapitalizationStatusEnum } from '../enums/capitalization-status.enum';
import { DropdownOptions } from './create-capitalization-modal/Steps/CapitalizationInfoStep';
import { CustoDropDownItemProps } from '../../../components/types';
import { FileIdentifiersCapitalizationType } from '../types/fileidentifiers.capitalization.type';
import FollowUpModal from '../../../components/GeneralFollowUpModal';
import { PurposesEnum } from '../../../enums/purposes.enum';
import { sendMessage } from '../../../services/generalfollowup';
import EstateUnitFilter from '../../../components/EstateUnitFilter';
import { appendEstateUnitIdToFilter } from '../../../utils/estateUnitFilter.util';
import { getListEmptyMessage } from '../../../utils/estateUnitEmptyState.util';
import AuthorizationContainer from '../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../enums/authz-feature.enum';
import { useDropDownUsers } from '../../../services/broker';
import { UsersToCustomDropDownOptions } from '../../../util';
import { useQuery } from '@tanstack/react-query';
import { FollowUpType } from '../../../types/FollowUp';
import { get } from '../../../services/storage';
import { isBackOfficeUser } from '../../../utils/isBackOfficeUser';
import TablePaginationMenu from '../../../components/TablePaginationMenu';
import Button from '../../../components/Button';
import { useLocation, useHistory } from 'react-router-dom';
import { isEstateRole } from '../../../utils/isEstateRole';
import PopupModal from '../../../components/PopupModal';
import { BannerLocationActivationEnum } from '../../../types/Banner';
import CapitalizationLenderInsuranceModal from './CapitalizationLenderInsuranceModal';
import { calculateAge } from '../../../utils/calculateAge';
import { typeOptions } from '../../fire-insurance/policy-list/types';

type SearchType = 'document' | 'name' | 'address';

const ClickableTableCell = styled(Table.Cell)`
  cursor: pointer;
  position: relative;
`;

const ClickableTableRow = styled(Table.Row)`
  :hover {
    background-color: #f0f0f0;
  }
`;

export const FieldLabel = styled.label<{ paddingTop?: boolean }>`
  font-weight: bold;
  padding-top: ${props => (props.paddingTop ? '14px' : '0px')};
  text-transform: uppercase;
  margin-left: 5px;
`;

export const FieldValue = styled.p`
  padding-left: 5px;
`;

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

interface LocationState {
  capitalizationId?: string;
}

const CapitalizationTable = (props: any) => {
  const location = useLocation();
  const history = useHistory();
  const { availableBrokersAndEstates, user, insurers } = props;
  const estates: CustoDropDownItemProps[] = availableBrokersAndEstates.estates;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [start, setStart] = useState<Date | null>();
  const [end, setEnd] = useState<Date | null>();
  const [selectedEstate, setSelectedEstate] = useState<any>();
  const [estateUnitIdFilter, setEstateUnitIdFilter] = useState('');
  const [selectedInsurer, setSelectedInsurer] = useState<any>();
  const [status, setStatus] = useState<any>();
  const [type, setType] = useState<SearchType>('name');
  const [argument, setArgument] = useState('');
  const [cleanInputs, setCleanInputs] = useState(false);
  const [selectedCapitalization, setSelectedCapitalization] = useState<any>(false);
  const [openDetail, setOpenDetail] = useState<boolean>(false);
  const [idFollowUp, setIdFollowUp] = useState<string>('');
  const [bondInsuranceIdOpen, setBondInsuranceIdOpen] = useState<string>('');
  const [statusOptions, setStatusOptions] = useState<DropdownOptions[]>([]);
  const [openFollowUp, setOpenFollowUp] = useState<boolean>(false);
  const [selectedAccountManager, setSelectedAccountManager] = useState<string | null>(
    null
  );
  const [total, setTotal] = useState<number>(0);
  const [isEnabledToFetch, setIsEnabledToFetch] = useState(false);
  const [capitalizationId, setCapitalizationId] = useState<string | null>(null);
  const [openLenderInsuranceModal, setOpenLenderInsuranceModal] = useState<boolean>(false);
  const [selectedCapitalizationForLender, setSelectedCapitalizationForLender] =
    useState<ListCapitalizationInterface | null>(null);
  const isBackOffice = isBackOfficeUser();
  const isEstateUser = isEstateRole(user?.role);
  const activeEstateId =
    availableBrokersAndEstates?.activeEstateId || user?.activeEstateId || user?.estate?.id;
  const globalLenderInsuranceEnabled = useSelector(
    (state: iRootState) => state.availableBrokersAndEstates.lenderInsuranceEnabled ?? false
  );
  const globalLenderInsuranceRate = useSelector(
    (state: iRootState) => state.availableBrokersAndEstates.lenderInsuranceRate
  );

  const isLenderInsuranceEnabledForItem = (item: ListCapitalizationInterface) => {
    const camelCaseFlag = item.estate?.lenderInsuranceEnabled;
    const snakeCaseFlag = (item.estate as any)?.lender_insurance_enabled;

    if (typeof camelCaseFlag === 'boolean') return camelCaseFlag;
    if (typeof snakeCaseFlag === 'boolean') return snakeCaseFlag;

    return globalLenderInsuranceEnabled;
  };

  useEffect(() => {
    const capIdFromLocation = (location.state as LocationState)?.capitalizationId;
    const capIdFromQuery = new URLSearchParams(location.search).get('id');
    setCapitalizationId(capIdFromLocation || capIdFromQuery || null);
  }, [location.state, location.search]);

  const handleOpen = () => {
    setOpenFollowUp(true);
  };

  const handleClose = () => {
    setOpenFollowUp(false);
  };

  const { data: usersData, isLoading: isAccountManagerLoading } = useDropDownUsers(
    props?.user?.broker?.id
  );

  const accountManagerOptions = React.useMemo(() => {
    if (!usersData) return [];

    const convertedUsers = usersData.map((user: any) => ({
      id: user.id,
      name: user.name
    }));

    return UsersToCustomDropDownOptions(false, convertedUsers);
  }, [usersData]);

  useEffect(() => {
    const statusDropdownOptions = Object.keys(CapitalizationStatusEnum).map(
      (key, index) => ({
        index,
        value: key,
        text: translateStatusCapitalization(
          (CapitalizationStatusEnum as any)[key] as string
        )
      })
    );
    setStatusOptions(statusDropdownOptions);
  }, []);

  useEffect(() => {
    setOpenFollowUp(!!idFollowUp.length);
  }, [idFollowUp]);

  useEffect(() => {
    if (!!estates.length) {
      if (isEstateUser) {
        const activeEstateOption =
          estates.find(estate => estate?.value?.id === activeEstateId) || estates[0];

        if (activeEstateOption?.value?.id !== selectedEstate?.id) {
          setSelectedEstate(activeEstateOption.value);
        }
      }
    }
  }, [activeEstateId, estates, isEstateUser, selectedEstate?.id]);

  const handleNewChangeEstate = (estateKey: any) => {
    const selected = estates.find(c => c.value.id === estateKey.id);
    if (!selected) {
      setSelectedEstate(0);
      return;
    }
    setSelectedEstate(estateKey);
  };

  const fetchCapitalizations = async () => {
    const userId = get('uid');
    const selectedEstateId = selectedEstate?.id;
    const fallbackEstateId = estates?.[0]?.value?.id || null;
    const estateId = isEstateUser
      ? selectedEstateId || activeEstateId || fallbackEstateId
      : estates && estates.length > 0
        ? estates.length > 1
          ? selectedEstateId || null
          : fallbackEstateId
        : null;

    let searchTerm = argument;
    if (type === 'document' && searchTerm) {
      searchTerm = searchTerm.replace(/[^\d]+/g, '');
    }

    const filters: any = appendEstateUnitIdToFilter(
      {
      page: currentPage,
      estateId,
      insurerId: selectedInsurer || null,
      status: status || null,
      start: start ? moment(start).format('YYYY-MM-DD') : null,
      end: end ? moment(end).format('YYYY-MM-DD') : null,
      [type]: searchTerm || null,
      onlyUnread: false,
      userId,
      accountManager: selectedAccountManager || null,
      isRv: true
      },
      estateUnitIdFilter
    );
    if (capitalizationId) {
      filters.id = capitalizationId;
    }
    const response = await getCapitalizations(filters);

    if (currentPage === 1) setTotal(response.count);

    return {
      data: response.data,
      count: currentPage === 1 ? response.count : total
    };
  };

  const {
    data: capitalizationsData,
    isFetching: isLoading,
    refetch: refetchCapitalizations
  } = useQuery(
    [
      'getCapitalizations',
      cleanInputs,
      currentPage,
      capitalizationId,
      selectedEstate?.id,
      activeEstateId
    ],
    fetchCapitalizations,
    {
      keepPreviousData: true,
      refetchOnMount: true,
      staleTime: 5000,
      enabled: !!capitalizationId || (!!estates.length && isEnabledToFetch)
    }
  );

  const clearFilters = () => {
    if (
      user.role !== UserRolesEnum.estateAdmin &&
      user.role !== UserRolesEnum.estateUser
    ) {
      setSelectedEstate(null);
    }
    setSelectedInsurer(null);
    setStatus(null);
    setType('name');
    setArgument('');
    setStart(null);
    setEnd(null);
    setSelectedAccountManager(null);
    setEstateUnitIdFilter('');
    setCapitalizationId(null);

    const currentLocState = location.state as LocationState;
    if (currentLocState?.capitalizationId) {
      const newState = { ...currentLocState };
      delete newState.capitalizationId;
      history.replace({ ...location, state: newState });
    }

    setCleanInputs(!cleanInputs);
    setCurrentPage(1);
  };

  const { data = [], count = 0 } = capitalizationsData || {};

  const openDetailModal = (capitalization: any) => {
    setSelectedCapitalization(capitalization);
    setOpenDetail(true);
  };

  const changeDate = (date: Date, type: string) => {
    if (type === 'start') {
      setStart(date);
    } else {
      setEnd(date);
    }
  };

  async function callback(fileTypes: string[], capitalization_id: string) {
    if (fileTypes) {
      let message = 'Foram anexados os seguintes arquivos: ';
      message += `${fileTypes.join(', ')}.`;
      try {
        await sendMessage(
          capitalization_id,
          user.id,
          message,
          user.name,
          'CAPITALIZATION',
          null,
          null,
          capitalization_id,
          false
        );
      } catch (err) {
        console.log(err);
      }
    }
  }

  const handleNewChangeAccountManager = (accountManagerKey: any) => {
    if (!!accountManagerKey.length) {
      setSelectedAccountManager(accountManagerKey);
    } else {
      setSelectedAccountManager(null);
    }
  };

  const handleCalcUnread = (followup: FollowUpType[], idUser: string) => {
    if (idUser === '') return 0;

    if (!followup || followup.length === 0) return 0;

    let count = 0;
    followup.forEach(item => {
      const dontCount = user.role.includes('ESTATE') && item.isInternal;
      if (item.viewedBy && item.viewedBy?.length > 0 && !dontCount) {
        if (!item.viewedBy.includes(idUser)) count++;
      }
    });
    return count;
  };

  useEffect(() => {
    if (!isBackOffice) {
      setIsEnabledToFetch(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterEstateId = String(
    selectedEstate?.id || activeEstateId || estates?.[0]?.value?.id || ''
  );

  return (
    <>
      {openFollowUp && (
        <FollowUpModal
          isOpen={openFollowUp}
          onOpen={handleOpen}
          onClose={handleClose}
          header="Follow Up"
          id={bondInsuranceIdOpen}
          context={'CAPITALIZATION'}
          user={user}
        />
      )}

      <Grid style={{ margin: '10px 0' }}>
        <Grid.Row verticalAlign={'middle'}>
          <Grid.Column width={3}>
            <FieldLabel>Pesquisar por</FieldLabel>
            <Dropdown
              fluid
              search
              selection
              value={type}
              options={typeOptions}
              placeholder="Selecionar..."
              disabled={isLoading}
              onChange={(_, { value }) => {
                if (['document', 'name', 'address'].includes(value as string)) {
                  setType(value as SearchType);
                }
              }}
            />
          </Grid.Column>

          <Grid.Column width={4}>
            <FieldLabel>Termo de pesquisa:</FieldLabel>
            <Input
              fluid
              name="argument"
              value={argument}
              disabled={isLoading}
              onChange={(_, { value }) => setArgument(value)}
            />
          </Grid.Column>

          <Grid.Column width={3}>
            <FieldLabel>Seguradora</FieldLabel>
            <Dropdown
              fluid
              value={selectedInsurer}
              name="insurer"
              disabled={isLoading}
              options={insurers || []}
              placeholder="Selecionar..."
              search
              selection
              clearable
              onChange={(_, { value }) => setSelectedInsurer(value)}
            />
          </Grid.Column>

          {isBackOffice && (
            <Grid.Column width={3}>
              <FieldLabel>Imobiliária</FieldLabel>
              <Dropdown
                fluid
                value={selectedEstate}
                name="estate"
                defaultValue={
                  availableBrokersAndEstates.estates.length === 1
                    ? availableBrokersAndEstates.estates[0].value
                    : ''
                }
                disabled={isLoading || availableBrokersAndEstates.estates.length === 1}
                options={availableBrokersAndEstates.estates || []}
                placeholder="Selecionar..."
                search
                selection
                onChange={(_, { value }) => handleNewChangeEstate(value)}
                clearable
              />
            </Grid.Column>
          )}

          <EstateUnitFilter
            columnWidth={3}
            estateId={filterEstateId}
            value={estateUnitIdFilter}
            onChange={setEstateUnitIdFilter}
          />
        </Grid.Row>

        <Grid.Row verticalAlign={'middle'}>
          <Grid.Column width={3}>
            <FieldLabel>Status</FieldLabel>
            <Dropdown
              fluid
              value={status}
              name="status"
              disabled={isLoading}
              options={statusOptions}
              placeholder="Selecionar..."
              search
              selection
              onChange={(_, { value }) => setStatus(value)}
              clearable
            />
          </Grid.Column>

          {!user.role.includes('ESTATE') && (
            <Grid.Column width={3}>
              <FieldLabel>Gestor de contas</FieldLabel>
              <Dropdown
                fluid
                value={selectedAccountManager || undefined}
                name="accountManager"
                options={accountManagerOptions}
                disabled={isLoading || isAccountManagerLoading}
                loading={isAccountManagerLoading}
                placeholder="Selecionar..."
                search
                selection
                onChange={(_, { value }) => handleNewChangeAccountManager(value)}
                clearable
              />
            </Grid.Column>
          )}

          <Grid.Column width={3}>
            <FieldLabel>Data inicial</FieldLabel>
            <CustomDatePicker
              customInput={
                <AppMaskedInput
                  mask={[
                    /[0-9]/,
                    /[0-9]/,
                    '/',
                    /[0-9]/,
                    /[0-9]/,
                    '/',
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/
                  ]}
                />
              }
              dateFormat={'dd/MM/yyyy'}
              disabled={isLoading}
              max={end?.toLocaleDateString('pt-BR')}
              onChange={(e: Date) => changeDate(e, 'start')}
              value={start?.toLocaleDateString('pt-BR')}
            />
          </Grid.Column>

          <Grid.Column width={3}>
            <FieldLabel>Data final</FieldLabel>
            <CustomDatePicker
              customInput={
                <AppMaskedInput
                  mask={[
                    /[0-9]/,
                    /[0-9]/,
                    '/',
                    /[0-9]/,
                    /[0-9]/,
                    '/',
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/
                  ]}
                />
              }
              dateFormat={'dd/MM/yyyy'}
              disabled={isLoading}
              mine={start?.toLocaleDateString('pt-BR')}
              onChange={(e: Date) => changeDate(e, 'end')}
              value={end?.toLocaleDateString('pt-BR')}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column textAlign="right">
            <Button light onClick={clearFilters} content="Limpar" />

            <Button
              disabled={isLoading}
              onClick={() => {
                setCurrentPage(1);
                setIsEnabledToFetch(true);
                refetchCapitalizations();
              }}
              content="Pesquisar"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Table style={{ margin: '0 25px 20px' }} celled>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell textAlign={'center'}>Solicitado em</Table.HeaderCell>
            <Table.HeaderCell textAlign={'center'}>Seguradora</Table.HeaderCell>
            <Table.HeaderCell textAlign={'center'}>Imobiliária</Table.HeaderCell>
            <Table.HeaderCell textAlign={'center'}>Inquilino</Table.HeaderCell>
            <Table.HeaderCell textAlign={'center'}>Endereço</Table.HeaderCell>
            <Table.HeaderCell textAlign={'center'}>Status</Table.HeaderCell>
            <Table.HeaderCell textAlign={'center'}>Ações</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Dimmer.Dimmable as={Table.Body} dimmed={isLoading}>
          {isLoading && (
            <Dimmer active blurring>
              <Loader />
            </Dimmer>
          )}
          {data && data.length > 0 ? (
            <>
              {data.map((item: ListCapitalizationInterface) => {
                const unread = handleCalcUnread(item.followup ?? [], user.id ?? '');
                const {
                  id,
                  createdAt,
                  insurer,
                  estate,
                  status,
                  capitalizationTenant,
                  capitalizationProperty
                } = item;

                const fullAddress = `${capitalizationProperty.street}, ${capitalizationProperty.number
                  }${capitalizationProperty.complement
                    ? ` ${capitalizationProperty.complement}`
                    : ''
                  } - ${capitalizationProperty.district} - ${capitalizationProperty.city
                  } - ${capitalizationProperty.state}`;
                const address = `${capitalizationProperty.street}, ${capitalizationProperty.number
                  }${capitalizationProperty.complement
                    ? ` ${capitalizationProperty.complement}`
                    : ''
                  }`;
                const popupAddress = () => (
                  <>
                    <span>{fullAddress}</span>
                  </>
                );
                const createdAtFormatted = moment(createdAt)
                  .format(`DD/MM/YYYY HH:mm`)
                  .split(' ');
                return (
                  <>
                    <ClickableTableRow key={id!}>
                      <ClickableTableCell
                        onClick={() => openDetailModal(item)}
                        textAlign={'center'}
                        collapsing
                      >
                        {createdAtFormatted[0]} <br /> {createdAtFormatted[1]}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(item)}
                        textAlign={'center'}
                        width={2}
                        style={{
                          textOverflow: 'ellipsis',
                          wordWrap: 'nowrap'
                        }}
                      >
                        {insurer?.name ?? (
                          <span style={{ color: '#ccc' }}>Não atribuído</span>
                        )}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(item)}
                        textAlign={'center'}
                      >
                        {estate?.name}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(item)}
                        textAlign={'center'}
                      >
                        {capitalizationTenant.name}
                        <br />
                        <span style={{ color: '#777' }}>
                          ({maskCpfOrCnpj(capitalizationTenant.document)})
                        </span>
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(item)}
                        style={{ cursor: 'default' }}
                        textAlign={'center'}
                      >
                        <Popup
                          content={popupAddress}
                          as={Segment}
                          style={{ border: '2px solid #dfdfdf' }}
                          position={'left center'}
                          trigger={
                            <>
                              <span style={{ cursor: 'help' }}>{address}</span>
                              <br />
                              <span>
                                {item.locationType === PurposesEnum.residential
                                  ? '(Residêncial)'
                                  : '(Comercial)'}
                              </span>
                            </>
                          }
                        />
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(item)}
                        textAlign={'center'}
                      >
                        {translateStatusCapitalization(status)}
                      </ClickableTableCell>

                      <Table.Cell width={1}>
                        <Menu compact>
                          <Menu.Item>
                            <Button
                              primary
                              icon="chat"
                              onClick={() => {
                                setIdFollowUp(id);
                                setBondInsuranceIdOpen(id);
                                setOpenFollowUp(true);
                              }}
                            />
                            {unread !== 0 && (
                              <Label color="red" circular floating>
                                {unread}
                              </Label>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            <ModalAttachFiles
                              message={`Arquivos anexos para capitalização`}
                              trigger={<Button color="teal" icon="attach" />}
                              bondInsuranceId={id}
                              tableName={'capitalization'}
                              fileIdentifiers={FileIdentifiersCapitalizationType}
                              callback={data => callback(data, id)}
                              brokerOnly={true}
                            />
                          </Menu.Item>
                          {isLenderInsuranceEnabledForItem(item) && (() => {
                            const tenantDocument = (item.capitalizationTenant?.document || '').replace(/\D/g, '');
                            const isTenantPf = tenantDocument.length === 11;
                            if (!isTenantPf) return null;

                            const tenantBirthDate = item.capitalizationTenant?.birthDate || '';
                            const tenantAge = tenantBirthDate ? calculateAge(tenantBirthDate) : 0;
                            if (tenantAge >= 65) return null;

                            return (
                              <Menu.Item>
                                <Popup
                                  content={
                                    item.lenderInsuranceId
                                      ? 'Gerenciar Seguro Prestamista'
                                      : 'Adicionar Seguro Prestamista'
                                  }
                                  trigger={
                                    <Button
                                      color={item.lenderInsuranceId ? 'green' : 'purple'}
                                      icon="shield"
                                      basic={!item.lenderInsuranceId}
                                      onClick={() => {
                                        setSelectedCapitalizationForLender(item);
                                        setOpenLenderInsuranceModal(true);
                                      }}
                                    />
                                  }
                                />
                              </Menu.Item>
                            );
                          })()}
                          <AuthorizationContainer
                            action={ActionEnum.update}
                            feature={FeatureEnum.captalizations}
                          >
                            <Menu.Item>
                              <EditCapitalizationModal
                                capitalization={item}
                                trigger={
                                  <Button color="yellow" icon="pencil alternate" />
                                }
                                insurers={insurers}
                              />
                            </Menu.Item>
                          </AuthorizationContainer>
                        </Menu>
                      </Table.Cell>
                    </ClickableTableRow>
                  </>
                );
              })}
            </>
          ) : (
            <Table.Row>
              <Table.Cell colSpan={9} textAlign={'center'}>
                <span>{getListEmptyMessage(props.user?.role, props.user?.estateUnitId)}</span>
              </Table.Cell>
            </Table.Row>
          )}
        </Dimmer.Dimmable>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={9} textAlign={'right'}>
              {!isLoading && (
                <TablePaginationMenu
                  currentPage={currentPage}
                  dataCount={count}
                  setCurrentPage={setCurrentPage}
                />
              )}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      <DetailModal
        open={openDetail}
        capitalization={selectedCapitalization}
        close={() => setOpenDetail(false)}
      />
      {selectedCapitalizationForLender && (
        <CapitalizationLenderInsuranceModal
          open={openLenderInsuranceModal}
          onClose={() => {
            setOpenLenderInsuranceModal(false);
            setSelectedCapitalizationForLender(null);
          }}
          onSuccess={() => {
            refetchCapitalizations();
          }}
          capitalization={selectedCapitalizationForLender}
          rate={
            selectedCapitalizationForLender?.estate?.lenderInsuranceRate ??
            globalLenderInsuranceRate ??
            19.9
          }
          isTenantPF={(selectedCapitalizationForLender?.capitalizationTenant?.document || '').replace(/\D/g, '').length === 11}
        />
      )}
      <PopupModal
        locationActivation={BannerLocationActivationEnum.CAPIITALIZATION_LIST}
      />
    </>
  );
};
export default connect(mapState, mapDispatch)(CapitalizationTable);
